<template>
  <!-- 默认内容部分 -->
  <div
    :class="[
      'content-default',
      { 'content-default--fullscreen': isFullscreen },
    ]"
  >
    <div class="right-content">
      <div class="content-default__title">
        <p class="logo">
          <img src="../../assets/imgs/ai-logo.png" alt="" />
        </p>
        <p class="logo-title">
          <span>你好，我是</span> <br /><span>麒麟 AI 助手</span>
        </p>
        <p class="logo-text">随时为您提供专业的智能服务支持</p>
      </div>
      <div class="login-btn-warp">
        <!-- <div class="quick-register" @click="handleRegister()">快速注册</div> -->
        <!-- <div class="quick-login" @click="handleLogin()">一键登录</div> -->
      </div>
      <div class="content-default__btn">
        <div class="btn-warp" @click="handleQuickStart(1)">
          <p>银河麒麟服务器操作系统V11产品介绍</p>
          <img src="../../assets/imgs/arrow-right.png" alt="" />
        </div>
        <div class="btn-warp" @click="handleQuickStart(2)">
          <p>银河麒麟桌面操作系统 V11产品介绍</p>
          <img src="../../assets/imgs/arrow-right.png" alt="" />
        </div>
        <div class="btn-warp" @click="handleQuickStart(3)">
          <p>服务器通用【将脚本转换为系统服务】操作方法</p>
          <img src="../../assets/imgs/arrow-right.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isFullscreen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      asideTop: 0,
    };
  },
  computed: {},
  watch: {},
  methods: {
    // 快速注册
    handleRegister() {
      this.$emit("register");
    },
    // 快速登录
    handleLogin() {
      this.$emit("login");
    },
    // 快速开始
    handleQuickStart(index) {
      let questionText = "";
      switch (index) {
        case 1:
          questionText = "银河麒麟服务器操作系统V11产品介绍";
          break;
        case 2:
          questionText = "银河麒麟桌面操作系统 V11产品介绍";
          break;
        case 3:
          questionText = "服务器通用【将脚本转换为系统服务】操作方法";
          break;
      }
      this.$emit("quickStart", questionText);
    },
  },
  mounted() {},
};
</script>

<style scoped lang="less">
.content-default {
  color: rgba(29, 29, 31, 0.95);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  &.content-default--fullscreen {
    padding: 0;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    margin-top: 60px;
    .right-content {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      .content-default__title {
        margin-top: 0;
        .logo-title {
          font-size: 28px;
          font-weight: 700;
          line-height: 40px;
        }
        .logo-text {
          margin-top: 17px;
        }
      }
      .login-btn-warp {
        margin-top: 24px;
      }
      .content-default__btn {
        margin-top: 24px;
      }
    }
  }
  .login-btn-warp {
    display: flex;
    align-items: center;
    margin-top: 17px;
    .quick-register,
    .quick-login {
      width: 135px;
      height: 35px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 14px;
      // border: 1px solid #fff;
      font-weight: 400;
      cursor: pointer;
      color: #e8354a;
      background-color: #f8f8f8;
      box-sizing: border-box;
      &:hover {
        background-color: #fff;
        border: 1px solid #e8354a;
      }
    }
    .quick-register {
      margin-right: 11px;
    }
  }
  .content-default__title {
    line-height: 34px;
    margin-top: 19px;
    .logo {
      text-align: center;
      img {
        width: 83px;
        height: 83px;
        object-fit: contain;
      }
    }
    .logo-title {
      text-align: center;
      line-height: 34px;
      font-size: 24px;
      font-weight: 700;
      span {
        display: inline-block;
        &:last-child {
          // 字体颜色渐变#833AB4 - #FD1D1D - #FCB045
          background: linear-gradient(90deg, #d31027 0%, #fe2a20 100%);
          background-clip: text;
          -webkit-text-fill-color: transparent;
        }
      }
    }
    .logo-text {
      text-align: center;
      font-size: 14px;
      color: #000;
      line-height: 22px;
      font-weight: 400;
      margin-top: 9px;
    }
  }
  .content-default__btn {
    margin-top: 18px;
    padding-bottom: 30px;
    .btn-warp {
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border: 1px solid #ecebeb;
      border-radius: 10px;
      width: 360px;
      height: auto;
      padding-left: 19px;
      padding-right: 15px;
      padding-top: 12px;
      padding-bottom: 12px;
      cursor: pointer;
      &:hover {
        background-color: #f5f5f5;
      }
      p {
        line-height: 22px;
        font-size: 14px;
        font-weight: 400;
      }
      img {
        margin-left: 10px;
        width: 16px;
        height: 16px;
      }
      &:nth-child(2) {
        margin-top: 12px;
      }
      &:nth-child(3) {
        margin-top: 12px;
      }
    }
  }
}
</style>
